import React from "react";

import CircularStatic from "../../components/CircularLoading";
import BigLoading from "../../components/BigLoading";
import FullPageLayout from "../../layouts/FullPage";

const Loading = () => (
  <FullPageLayout>
    <BigLoading />
  </FullPageLayout>
);

export default Loading;
